import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon } from 'lucide-react';
import { useForm } from '@formspree/react';
export function Contact() {
  const [state, handleSubmit] = useForm('myzbzjjn');
  return <div className="w-full bg-black" data-id="element-118">
      <Helmet data-id="element-119">
        <title data-id="element-120">Contact Us - Western Royal Diesel</title>
        <meta name="description" content="Get in touch with Western Royal Diesel for a free consultation and pricing quote" data-id="element-121" />
      </Helmet>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-black via-gray-900 to-black text-white py-16 md:py-24 border-b border-cyan-500/20" data-id="element-122">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent" data-id="element-124">
            Contact Us
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl" data-id="element-125">
            Ready to upgrade your diesel vehicle? Get in touch with us for a
            free consultation and pricing quote.
          </p>
        </div>
      </section>
      {/* Contact Form and Info */}
      <section className="py-16 md:py-24 bg-gray-950" data-id="element-126">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-128">
            {/* Contact Form */}
            <div data-id="element-129">
              <h2 className="text-3xl font-bold mb-6 text-white" data-id="element-130">
                Request a Quote
              </h2>
              {state.succeeded ? <div className="bg-green-500/10 border border-green-500/50 rounded-lg p-6 text-center" data-id="element-131">
                  <p className="text-green-400 text-lg font-semibold" data-id="element-132">
                    Thank you for your inquiry!
                  </p>
                  <p className="text-gray-300 mt-2" data-id="element-133">
                    We'll get back to you within 24 hours.
                  </p>
                </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-134">
                  <div data-id="element-135">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-136">
                      Name *
                    </label>
                    <input type="text" id="name" name="name" required className="w-full px-4 py-3 bg-gray-900 border border-cyan-500/30 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent text-white" data-id="element-137" />
                  </div>
                  <div data-id="element-138">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-139">
                      Email *
                    </label>
                    <input type="email" id="email" name="email" required className="w-full px-4 py-3 bg-gray-900 border border-cyan-500/30 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent text-white" data-id="element-140" />
                  </div>
                  <div data-id="element-141">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-142">
                      Phone
                    </label>
                    <input type="tel" id="phone" name="phone" className="w-full px-4 py-3 bg-gray-900 border border-cyan-500/30 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent text-white" data-id="element-143" />
                  </div>
                  <div data-id="element-144">
                    <label htmlFor="service" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-145">
                      Service Interested In *
                    </label>
                    <select id="service" name="service" required className="w-full px-4 py-3 bg-gray-900 border border-cyan-500/30 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent text-white" data-id="element-146">
                      <option value="" data-id="element-147">Select a service</option>
                      <option value="performance" data-id="element-148">Diesel Performance</option>
                      <option value="wrapping" data-id="element-149">Vehicle Wrapping</option>
                      <option value="tinting" data-id="element-150">Window Tinting</option>
                      <option value="multiple" data-id="element-151">Multiple Services</option>
                    </select>
                  </div>
                  <div data-id="element-152">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-153">
                      Message *
                    </label>
                    <textarea id="message" name="message" required rows={5} className="w-full px-4 py-3 bg-gray-900 border border-cyan-500/30 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent text-white" placeholder="Tell us about your vehicle and what you're looking for..." data-id="element-154" />
                  </div>
                  <button type="submit" disabled={state.submitting} className="w-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white px-6 py-4 rounded-lg text-lg font-semibold transition-all shadow-lg shadow-cyan-500/50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-155">
                    {state.submitting ? 'Sending...' : 'Submit Inquiry'}
                  </button>
                </form>}
            </div>
            {/* Contact Information */}
            <div data-id="element-156">
              <h2 className="text-3xl font-bold mb-6 text-white" data-id="element-157">
                Get In Touch
              </h2>
              <div className="space-y-6" data-id="element-158">
                <div className="flex items-start gap-4 bg-gray-900 p-4 rounded-lg border border-green-500/30" data-id="element-159">
                  <div className="bg-gradient-to-br from-green-500 to-cyan-500 text-white p-3 rounded-lg" data-id="element-160">
                    <MapPinIcon size={24} data-id="element-161" />
                  </div>
                  <div data-id="element-162">
                    <h3 className="font-semibold text-lg mb-1 text-green-400" data-id="element-163">
                      Location
                    </h3>
                    <p className="text-gray-400" data-id="element-164">
                      34675 Gaudraut Ct, Elizabeth, CO 80107
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-gray-900 p-4 rounded-lg border border-blue-500/30" data-id="element-165">
                  <div className="bg-gradient-to-br from-blue-500 to-cyan-500 text-white p-3 rounded-lg" data-id="element-166">
                    <PhoneIcon size={24} data-id="element-167" />
                  </div>
                  <div data-id="element-168">
                    <h3 className="font-semibold text-lg mb-1 text-blue-400" data-id="element-169">
                      Phone
                    </h3>
                    <p className="text-gray-400" data-id="element-170">(720) 662-0910</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-gray-900 p-4 rounded-lg border border-cyan-500/30" data-id="element-171">
                  <div className="bg-gradient-to-br from-cyan-500 to-blue-500 text-white p-3 rounded-lg" data-id="element-172">
                    <MailIcon size={24} data-id="element-173" />
                  </div>
                  <div data-id="element-174">
                    <h3 className="font-semibold text-lg mb-1 text-cyan-400" data-id="element-175">
                      Email
                    </h3>
                    <p className="text-gray-400" data-id="element-176">
                      westernroyaldiesel@gmail.com
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-gray-900 p-4 rounded-lg border border-green-500/30" data-id="element-177">
                  <div className="bg-gradient-to-br from-green-500 to-cyan-500 text-white p-3 rounded-lg" data-id="element-178">
                    <ClockIcon size={24} data-id="element-179" />
                  </div>
                  <div data-id="element-180">
                    <h3 className="font-semibold text-lg mb-1 text-green-400" data-id="element-181">
                      Business Hours
                    </h3>
                    <div className="text-gray-400 space-y-1" data-id="element-182">
                      <p data-id="element-183">Monday - Friday: 8:00 AM - 6:00 PM</p>
                      <p data-id="element-184">Saturday: 9:00 AM - 4:00 PM</p>
                      <p data-id="element-185">Sunday: Closed</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}